import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { Button } from "..";

interface ErrorProps {
    onRetry?: () => void;
}

export const Error: FC<ErrorProps> = (props) => {
    return (
        <>
            <div>Error</div>
            {!!props.onRetry && (
                <Button onClick={props.onRetry}>
                    <FontAwesomeIcon icon={faRefresh} />
                </Button>
            )}
        </>
    );
};